export const serviceOptions = (key, options = []) => {
  switch (key) {
    case 'BRANCH_OPTION':
      return options?.map((item) => ({
        label: item.label,
        value: item.value,
      }));
    default:
      return [];
  }
};
